import ES from './ES';
import EN from './EN';
import IT from './IT';

export default {
  ...ES,
  ...EN,
  ...IT,
};
